import {
  TripsFacetedListResponse,
  Trip_VehicleTypeEnum,
  Trip_PropulsionTypesEnum,
  TripOriginDestination_KindEnum,
  Trip_LocationTypesEnum,
  Trip,
} from 'src/api/gen/api'

export const shortData = [
  {
    id: '09fda23d-ae83-45b5-8c3f-dfeb0a020eb8',
    device_id: 'da710b3f-0228-4f2b-946c-ccfb0433bff4',
    provider_id: '2411d395-04f2-47c9-ab66-d09e9e3c3251',
    provider_name: 'Bird',
    vehicle_id: '1K7VK',
    vehicle_type: 'scooter',
    propulsion_types: ['electric'],
    time_since_last_trip: 39716137,
    start_time: '2019-08-26T15:22:19.478Z',
    end_time: '2019-08-26T15:28:24.626Z',
    start_dow: 1,
    end_dow: 1,
    duration: 365,
    distance: 0.640138825294736,
    speed: 6.311138965737316,
    origin: '33.987894,-118.458891',
    destination: '33.993748,-118.467552',
    origin_zones: {
      neighborhoods: ['VENICE NC'],
      dac_zones: ['nonDAC'],
      council_districts: ['11'],
    },
    destination_zones: {
      neighborhoods: ['VENICE NC'],
      dac_zones: ['nonDAC'],
      council_districts: ['11'],
    },
    indexed: 1567608124145,
  },
]

export const emptyData: Array<Trip> = [
  {
    id: '09fda23d-ae83-45b5-8c3f-dfeb0a020eb8',
    device_id: 'da710b3f-0228-4f2b-946c-ccfb0433bff4',
    provider_id: '2411d395-04f2-47c9-ab66-d09e9e3c3251',
    vehicle_id: '1K7VK',
    vehicle_type: Trip_VehicleTypeEnum.scooter,
    propulsion_types: [],
    location_types: [],
    start_time: '2019-08-26T15:22:19.478Z',
    end_time: '2019-08-26T15:28:24.626Z',
    duration: 0,
    distance: 0,
    speed: 0,
  },
]

export const tripListResponse: TripsFacetedListResponse = {
  number_of_matching_documents: 1,
  documents: [
    {
      id: '09fda23d-ae83-45b5-8c3f-dfeb0a020eb8',
      vehicle_id: '1K7VK',
      device_id: 'da710b3f-0228-4f2b-946c-ccfb0433bff4',
      start_time: '2019-08-26T15:22:19.478Z',
      end_time: '2019-08-26T15:28:24.626Z',
      duration: 365,
      distance: 0.640138825294736,
      speed: 6.311138965737316,
      provider_id: '2411d395-04f2-47c9-ab66-d09e9e3c3251',
      vehicle_type: Trip_VehicleTypeEnum.scooter,
      propulsion_types: [Trip_PropulsionTypesEnum.electric],
      location_types: [Trip_LocationTypesEnum.crosswalk],
    },
  ],
  aggregations: {
    provider_id: {
      '63f13c48-34ff-49d2-aca7-cf6a5b6171c3': 181,
    },
    vehicle_type: {
      scooter: 181,
    },
    duration_min: 1,
    duration_max: 100,
    distance_min: 1,
    distance_max: 1000,
  },
}

export const tripsOriginDestinationsCount = [
  {
    zoom: 16,
    x: 2,
    y: 4,
    trip_count: 30,
    kind: TripOriginDestination_KindEnum.origin,
  },
]

export const tripCountsInStreetSegments = {
  street_segments: {
    1: {
      name: 'avenue Foch',
      geojson: { type: 'MultiLineString', coordinates: [] },
    },
  },
  documents: [
    { key: '1', doc_count: 1 },
    { key: '2', doc_count: 3 },
  ],
  trips_per_street_min: 1,
  trips_per_street_max: 3,
  next_page: 1,
  total_page_num: 3,
}

export const streetSegmentsObjects = {
  '1': { street_segment_id: '1', street_name: 'streetName1', street_segment_points: [{ lon: 118, lat: 118 }] },
  '2': { street_segment_id: '2', street_name: 'streetName2', street_segment_points: [{ lon: -118, lat: -118 }] },
}
